import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class requestService {
  async create(obj) {
    try {
      const result = await client.post('request/create', obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async update(id, obj) {
    try {
      const result = await client.post(`request/update/${id}`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
  
  async fetch(params) {
    try {      
      const result = await client.get('request/index', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async get(id) {
    try {
      const result = await client.get(`request/view/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async approve(id, approvalCategory) {
    try {
      console.log("APPROVE ", approvalCategory);
      const result = await client.post(`request/approve/${id}`, {approvalCategory});
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async approvePending(approvalCategory) {
    try {
      const result = await client.post(`request/approvepending`, { approvalCategory });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async reject(id, data) {
    try {
      const result = await client.post(`request/reject/${id}`, data);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async remove(id) {
    try {
      const result = await client.post(`request/delete/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new requestService();
